// Verified historical validation records. Filtering is presentation-only; raw audit provenance is retained.
const validationIds = new Set([199,198,197,196,195,194,193,192,191,190,188,187,186,185,184,179,178,177,176,175,174,173,172,167,166,165,164,162,161,160,159,158,157,156,155,154,153,152,151,150,149,148,147]);

export function decodeJson(value: unknown): unknown {
  if (typeof value !== 'string') return value;
  try { return JSON.parse(value); } catch { return null; }
}

export function customerText(value: unknown): string {
  return String(value ?? '').replace(/openclaw[\s_-]*validation/gi, 'Validation account').replace(/openclaw(?:[\s_-]+web[\s_-]+ops)?/gi, 'Site maintenance');
}

export function actorLabel(username: unknown): string {
  const name = String(username ?? '');
  return name === 'fuel-sync' ? 'Automatic update' : customerText(name);
}

export function customerAuditRows<T extends { id?: unknown; username?: unknown; previousValue?: unknown; newValue?: unknown }>(rows: T[]): T[] {
  return rows.filter(row => !(row.username === 'openclaw_validation' && validationIds.has(Number(row.id))))
    .map(row => ({ ...row, previousValue: decodeJson(row.previousValue), newValue: decodeJson(row.newValue) } as T));
}

export function customerReleaseChanges(value: unknown): string[] {
  const decoded = decodeJson(value);
  return Array.isArray(decoded) ? decoded.filter(item => typeof item === 'string').map(customerText) : [];
}
